<div class="modal-header"  *ngIf="IsModal" >
  <h5 class="modal-title" id="editUserLabel">Task</h5>
  <button type="button" class="close" (click)="save()" aria-label="Save">
    <span aria-hidden="true">Salva</span>
  </button>
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [ngClass]="{'': IsModal, 'card': !IsModal }" *ngIf="!CampiAggiuntivi || environment.RmaAddOn['campiSum']">
  <div [ngClass]="{'modal-body': IsModal, 'card-body': !IsModal }">
    <div class="row">
      <div class="col-md-2 " *ngIf="Item?.id">
        <div class="form-group">
          <label class="control-label col-form-label">ID:</label>
          <input type="text" [readOnly]="Item?.id" [(ngModel)]="Item.id" class="form-control">
        </div>
      </div>
    <div class="col-md-4 ">
      <div class="form-group">
        <label for="nome" class="control-label col-form-label">Titolo:</label>
        <input type="text" #nome="ngModel" required [readOnly]="Item?.id" [(ngModel)]="Item.nome" class="form-control" id="nome" placeholder="Titolo">
        <small class="form-text text-danger" *ngIf="!nome.valid && (nome.dirty || nome.touched)">Campo richiesto!</small>
      </div>
    </div>
      <div class="col-lg-4">
        <label for="manager" class="control-label col-form-label">{{'Scadenza.cliente' | translate}}:</label>
        <ng-multiselect-dropdown [settings]="clientidropdownSettings" [placeholder]="'Scadenza.cliente' | translate" id="cliente" [data]="clienti"
                                 [(ngModel)]="clientiselezionati" (onFilterChange)="filtroCliente($event)" (ngModelChange)="filtroProdotti('')" >
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-4" *ngIf="!environment.RmaAddOn['hideProdotto']">
        <label for="manager" class="control-label col-form-label">Prodotto</label>
        <ng-multiselect-dropdown [settings]="prodottidropdownSettings" [placeholder]="'Scadenza.prodotto' | translate" id="prodotto" [data]="prodotti"
                                 [(ngModel)]="prodottiselezionati" (onFilterChange)="filtroProdotti($event)" >
        </ng-multiselect-dropdown>
      </div>

    <div class="col-3">
      <div class="form-group">
        <label for="data_inizio_prevista" class="control-label col-form-label">Data Task:</label>
        <input type="datetime-local" [(ngModel)]="Item.data_inizio_prevista" class="form-control" id="data_inizio_prevista">
      </div>
    </div>
    <div class="col-3">
      <div class="form-group">
        <label for="data_fine_prevista" class="control-label col-form-label">{{'Data Scadenza' | translate}}:</label>
        <input type="datetime-local" [(ngModel)]="Item.data_fine_prevista" class="form-control" id="data_fine_prevista">
      </div>
    </div>

    <div class="col-lg-3">
      <label for="manager" class="control-label col-form-label">{{'Scadenza.manager' | translate}}: *</label>
      <ng-multiselect-dropdown [settings]="utentidropdownSettings" [placeholder]="'Scadenza.manager' | translate" id="manager" [data]="Responsabili()"
                               [(ngModel)]="managerselezionati" (onFilterChange)="filtroResponsabile($event)" >
      </ng-multiselect-dropdown>
    </div>
    <div class="col-lg-3" *ngIf="environment.RmaAddOn['referente'] && clientiselezionati?.length > 0">
      <label for="manager" class="control-label col-form-label">{{'Scadenza.referente' | translate}}: *</label>
      <ng-multiselect-dropdown [settings]="utentidropdownSettings" [placeholder]="'Scadenza.referente' | translate" id="manager" [data]="Responsabili()"
                               [(ngModel)]="referente" >
      </ng-multiselect-dropdown>
    </div>
    <div class="col-md-2 " *ngIf="Item?.id">
      <div class="form-group">
        <label for="closed" class="control-label col-form-label">Concluso:</label>
        <input type="checkbox" #nome="ngModel" [readOnly]="!permission.isPermitted('gestione-attivita')"  [(ngModel)]="Item.chiuso" class="form-control" id="closed">
      </div>
    </div>

      <div class="col-md-12 "></div>
      <div class="col-3">
        <div class="form-group">
          <label for="data_inizio_effettiva" class="control-label col-form-label">{{'Scadenza.dataie' | translate}}:</label>
          <input type="datetime-local" [(ngModel)]="Item.data_inizio_effettiva" class="form-control" id="data_inizio_effettiva">
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <label for="data_fine_effettiva" class="control-label col-form-label">{{'Scadenza.datafe' | translate}}:</label>
          <input type="datetime-local" [(ngModel)]="Item.data_fine_effettiva" class="form-control" id="data_fine_effettiva">
        </div>
      </div>
      <div class="col-md-12 ">
        <div class="form-group">
          <label for="desc" class="control-label col-form-label">Descrizione:</label>
          <textarea type="text" #desc="ngModel" required [(ngModel)]="Item.note" [readOnly]="Item?.id" class="form-control" id="desc" placeholder="Descrizione"></textarea>
          <small class="form-text text-danger" *ngIf="!desc.valid && (desc.dirty || desc.touched)">Campo richiesto!</small>
        </div>
      </div>
      <div class="col-md-12 ">
        <div class="form-group">
          <label for="desc" class="control-label col-form-label">Note:</label>
          <textarea type="text" #desc="ngModel"  [(ngModel)]="Item.noteTecnico" rows="10"  class="form-control" id="notetec" placeholder="Note"></textarea>
        </div>
      </div>
      <div class="col-md-12 " *ngIf="environment.RmaAddOn['campiSum']">
        <app-field-viewer [(DropdownSources)]="DSource" (OnChange)="ChangeHandler($event)" [(Campi)]="CampiAggiuntivi" [(Oggetto)]="Item" ></app-field-viewer>
      </div>
    </div>
  </div>
      




</div>

<div class="card"  *ngIf="!CampiAggiuntivi || environment.RmaAddOn['hasCards']">
  <ul ngbNav #nav="ngbNav" activeId="attivita" class="nav-tabs">
    <li ngbNavItem="todo" >
      <a ngbNavLink> {{'Todo'|translate}} </a>
      <ng-template ngbNavContent>
        <div *ngIf="environment.TaskAddon.checkList">
          <app-check-list [(Items)]="Item.todo"></app-check-list>
        </div>
      </ng-template>
    </li>
    <li ngbNavItem="file" >
      <a ngbNavLink> {{'File'|translate}} </a>
      <ng-template ngbNavContent>
        <div *ngIf="environment.TaskAddon.checkList">
          <div *ngIf="Item?.id" class="card-body">
            <app-file-uploader [url]="'/rma/interventi/file'" [(id)]="Item.id" [ListaFile]="true" (onChange)="onFileChanged()"></app-file-uploader>
          </div>
        </div>
      </ng-template>
    </li>
    <li ngbNavItem="Partecipanti" >
      <a ngbNavLink> Partecipanti </a>
      <ng-template ngbNavContent>
        <app-partecipanti-list class="col-12" [rest]="false" [List]="Item.partecipantiObject" [hasAddButton]="true"  [Padre]="Item" ></app-partecipanti-list>
      </ng-template>
    </li>
    <li ngbNavItem="Tempi">
      <a ngbNavLink> Tempi </a>
      <ng-template ngbNavContent>
        <app-Shered-tempi-list class="col-12" [List]="Item.tempi" (onChange)="this.refresh()" [hasAddButton]="permission.isPermitted('gestione-segnalazione') " [url]="'/rma/tempi'" [ModificheAbilitate]="true" [Padre]="Item" ></app-Shered-tempi-list>
      </ng-template>
    </li>
<li ngbNavItem="interventi" *ngIf="Item?.id && environment.RmaAddOn['InterventiFigli'] && !selected?.padre ">
  <a ngbNavLink> {{'Interventi'|translate}} </a>
  <ng-template ngbNavContent>
    <div style="    margin-inline: 0.75rem;"
      >
      <div class="d-md-flex align-items-center  p-2" style="background-color: #ffffff;">
        <div class="ml-auto mt-3 mt-md-0" *ngIf="!permission.isOperativeRole('CA')">
          <button type="button" (click)="AddRma()" [disabled]="!CanAddFigli()" 
            [ngbTooltip]="CanAddFigli()? '': 'Per Aggiungere un intervento bisogna aver spuntato i 4 check di controllo'"
            class="btn btn-cyan rounded-pill p-2"><i class="fas fa-plus  font-14 mr-1 text-white"></i>
            <span class="ml-1 text-white font-weight-bold">{{'RMA.add' | translate}}</span>
          </button>
        </div>
      </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0 HorizontalTable">
            <thead>
        <tr *ngIf="!(environment.RmaAddOn['headersTaskboard']?.length > 0)">
          
          <th scope="col" (click)="order({nome: 'id', oggetti:['id']})">Id</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['nome']})">Titolo</th>
          <th scope="col">{{'Scadenza.cliente' | translate}}</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['data_inizio_prevista'], inputType: 'datetime-local'})">Data
            di Segnalazione</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['data_fine_prevista'], inputType: 'datetime-local'})">Data di
            Scadenza</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['data_inizio_effettiva'], inputType: 'datetime-local'})">Data
            di Inizio</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['data_fine_effettiva'], inputType: 'datetime-local'})">Data
            di Fine</th>
          <th scope="col">Responsabile</th>
          <th scope="col">Azioni</th>
        </tr>
              <tr *ngIf="environment.RmaAddOn['headersTaskboard']?.length > 0 ">
                <ng-container *ngFor="let campo of environment.RmaAddOn['headersTaskboard']">
                  <th scope="col" *ngIf="campoUtility.Show(campo, {},false)">{{campo.nome}}</th>
                </ng-container>
                <th scope="col">Azioni</th>
              </tr>
            </thead>
            <tbody *ngIf="environment.RmaAddOn['headersTaskboard']?.length > 0 ">
              <tr *ngFor="let item of Item['interventi']">
                <ng-container *ngFor="let campo of Header()">
                  <td>
                    <span [ngClass]="{'badge badge-pill ': campoUtility.Colore(campo,item)!= undefined }"
                      [ngStyle]="{'background-color': campoUtility.Colore(campo,item), 'font-size':'14px'} ">
                      <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
                        <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'date' && item[oggetto]">
                          {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy'}} &nbsp;
                        </ng-template>
                        <ng-template
                          [ngIf]="campo.type == 'object' && campo.inputType == 'date' && campoUtility.getObj(item, oggetto) ">
                          {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy'}} &nbsp;
                        </ng-template>
                        <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'datetime-local' && item[oggetto]">
                          {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy HH:mm'}} &nbsp;
                        </ng-template>
                        <ng-template
                          [ngIf]="campo.type == 'object' && campo.inputType == 'datetime-local' && campoUtility.getObj(item, oggetto)">
                          {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy HH:mm'}} &nbsp;
                        </ng-template>
                        <ng-template
                          [ngIf]="campo.type!= 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local'  && campo.type != 'replace' && campo.type != 'objArray'">
                          {{campoUtility.getObj(item, oggetto)}} &nbsp;
                        </ng-template>
                        <ng-template
                          [ngIf]="campo.type == 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && item[oggetto] && campoUtility.getObj(item, oggetto)">
                          {{campoUtility.getObj(item, oggetto)[campo.field[i]]}} &nbsp;
                        </ng-template>
                        <ng-template
                          [ngIf]="campo.type == 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && !item[oggetto] && campo.oggettisec && campo.oggettisec[i] && item[campo.oggettisec[i]]">
                          {{item[campo.oggettisec[i]][campo.field[i]]}} &nbsp;
                        </ng-template>
                        <ng-template [ngIf]="campo.type == 'replace' ">
                          {{campoUtility.Replace(campo, item, oggetto)}} &nbsp;
                        </ng-template>
                        <ng-template [ngIf]="campo.type == 'objArray' ">
                          <ng-container *ngFor="let obg of campoUtility.getObj(item, oggetto)">
                            {{obg[campo.field[i]]}} &nbsp;
                          </ng-container>
                        </ng-template>
                      </ng-container>
                    </span>
                  </td>
                </ng-container>
            
                <td class="align-middle">
                  <a *ngIf="permission.HasCapacity(['gestione-attivita'])" href="javascript:void(0)" ngbTooltip="Modifica"
                    class="link font-16 text-info font-medium mr-2" (click)='edit(item)'>
                    <i-feather name="edit-3" class="feather-sm"></i-feather>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="!(environment.RmaAddOn['headersTaskboard']?.length > 0)">
              <tr *ngFor="let item of Item['interventi'] ">
               
                <td (click)='edit(item)'>
            
                  <span class="badge badge-pill px-3   font-14">
                    {{item?.id}}</span>
                </td>
                <td (click)='edit(item)'>
            
                  <span class="badge badge-pill px-3   font-14">
                    {{item?.nome}}</span>
                </td>
                <td (click)='edit(item)'>
            
                  <span class="badge badge-pill px-3   font-14">
                    {{item?.clienteObject?.nominativo ?? ''}}</span>
                </td>
                <td (click)='edit(item)'>
                  <span class="badge badge-pill px-3   font-14">
                    {{item?.data_inizio_prevista | date: 'dd/MM/yyyy HH:mm'}}</span>
                </td>
                <td (click)='edit(item)'>
                  <span class="badge badge-pill px-3   font-14">
                    {{item?.data_fine_prevista | date: 'dd/MM/yyyy HH:mm'}}</span>
                </td>
                <td (click)='edit(item)'>
                  <span class="badge badge-pill px-3   font-14">
                    {{item?.data_inizio_effettiva | date: 'dd/MM/yyyy HH:mm'}}</span>
                </td>
                <td (click)='edit(item)'>
                  <span class="badge badge-pill px-3   font-14">
                    {{item?.data_fine_effettiva | date: 'dd/MM/yyyy HH:mm'}}</span>
                </td>
                <td (click)='edit(item)'>
                  <span class="badge badge-pill px-3   font-14">
                    {{item?.managerObject?.fullName }}</span>
                </td>
                <td class="align-middle">
                  <a *ngIf="permission.HasCapacity(['gestione-attivita'])" href="javascript:void(0)" ngbTooltip="Modifica"
                    class="link font-16 text-info font-medium mr-2" (click)='edit(item)'>
                    <i-feather name="edit-3" class="feather-sm"></i-feather>
                  </a>
                  <a *ngIf="permission.HasCapacity(['gestione-attivita'])" href="javascript:void(0)" ngbTooltip="Elimina"
                    class="link font-16 text-danger font-weight-bold" (click)='Deleterma(item)'>
                    <i-feather name="trash-2" class="feather-sm"></i-feather>
                  </a>
                </td>
              </tr>
            </tbody>

      </table>
     
    </div>
    </div>
  </ng-template>
</li>
    <li ngbNavItem="attivita"  *ngIf="Item?.id && permission.isPermitted('gestione-segnalazione') && !permission.isOperativeRoles(['C','AC']) && environment.RmaAddOn.sottoTask">
      <a ngbNavLink> {{'RMA.attivita.title'|translate}} </a>
      <ng-template ngbNavContent>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3">
                <input [(ngModel)]="TitoloScadenza" placeholder="Titolo" type="text" name="voce" (keyup.enter)="focusDescr()" class="form-control">
              </div>
              <div class="col-lg-4">
                <textarea [(ngModel)]="DescrizioneScadenza" #descr placeholder="Descrizione" name="descrizione" type="text" (keyup.enter)="AggiungiScadenzaInline()" class="form-control"></textarea>
              </div>
              <div class="col-lg-3">
                <ng-multiselect-dropdown [settings]="utentidropdownSettings" placeholder="Responsabile" id="managerScadenza" [data]="managers"
                                         [(ngModel)]="segnalazionemanagerselezionati" (onFilterChange)="filtroResponsabile($event)" >
                </ng-multiselect-dropdown>
              </div>
              <div class=" mt-3 mt-md-0 p-1">
                <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="AggiungiScadenzaInline()" type="button">Aggiungi</button>
              </div>
            </div>
          </div>
        </div>
        <app-attivita-rma [(ListaScadenze)]="Item.figli" [hideAdd]="true"  (AddButtonClick)="ScadAddButton()" (Updated)="refresh()"></app-attivita-rma>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
<div [ngClass]="{'': IsModal, 'card': !IsModal }" *ngIf="CampiAggiuntivi && Item && !environment.RmaAddOn['campiSum']">
  <app-sector-viewer [(DropdownSources)]="DSource" (OnChange)="ChangeHandler($event)" [(Campi)]="CampiAggiuntivi" [(Oggetto)]="Item"></app-sector-viewer>
</div>
<div [ngClass]="{'': IsModal, 'card': !IsModal }" *ngIf="CampiAggiuntivi && Item && !environment.RmaAddOn['campiSum'] &&environment.RmaAddOn['partecipantseparati']">
  <app-partecipanti-list class="col-12" [rest]="false" [List]="Item.partecipantiObject" [hasAddButton]="true"  [Padre]="Item" ></app-partecipanti-list>
</div> 
<div class="d-md-flex align-items-center justify-content-end m-b-10 m-r-10">
  <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>
  <button *ngIf="environment['TaskAddon']['indiretti'] && mostraPulsanteIndiretti"
  type="button"
  (click)="AggiungiBeneficiariIndiretti()"
  style="margin: 0.75px;"
  class="btn btn-primary waves-effect waves-light">
<span class="mr-1 text-white"> Aggiungi beneficiari indiretti </span>
<i class="fas fa-user-plus text-white"></i>
</button>
  <button type="submit" (click)="save()" style="margin: 0.75px;" class=" btn btn-success  waves-effect waves-light">
    <span class="mr-1 text-white "> Salva </span>
    <i class="far fa-save text-white"></i>
  </button>
  <button type="submit" (click)="save(true)" style="margin: 0.75px;" class=" btn btn-success  waves-effect waves-light">
    <span class="mr-1 text-white "> Salva e chiudi </span>
    <i class="far fa-save text-white"></i>
  </button>
  <button type="submit" (click)="close()"  style="margin: 0.75px;" class=" btn btn-danger  waves-effect waves-light">
    <span class="mr-1 text-white "> Chiudi </span>
    <i class="far fa-window-close text-white"></i>
  </button>
</div>
